import _ from 'lodash'

const getter = (dataPath, {serviceTopology}) => _.get(serviceTopology, dataPath)

export default getter
